import React from 'react';
import PropTypes from 'prop-types';

import Link from '../../../../library/link/link';
import Pill from '../../../../library/pill/pill';

import styles from './cms-article-list.scss';

function CmsArticleList(props) {
  const { articles } = props;

  return (
    <div className={styles['container']}>
      {Array.isArray(articles) &&
        articles.map((article, idx) => {
          const { category, image, info, link, title } = article;
          return (
            <article className={styles['article']} key={`cal-${idx}`}>
              <Link to={link?.href}>
                <div
                  className={styles['image']}
                  style={{ backgroundImage: `url(${image?.url})` }}
                >
                  <Pill className={styles['category']}>{category}</Pill>
                </div>

                <div className={styles['summary']}>
                  <h4 className={styles['title']}>{title}</h4>
                  <p className={styles['info']}>{info}</p>
                </div>
              </Link>
            </article>
          );
        })}
    </div>
  );
}

CmsArticleList.propTypes = {
  articles: PropTypes.array
};

export default CmsArticleList;
